import { all, takeEvery, put, call } from 'redux-saga/effects';
import ApiInstance from 'src/helpers/apiInstance';
import actions from './actions';
import { tableConfig } from '../../../../../settings/index';
import { sendRequest } from '../../../../../helpers/saga';
import { logger } from '../../../../../helpers/logger';
import notifications from '../../../../../redux/notifications/actions';

const api = new ApiInstance('subunits');

function* loadData(data) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id: parent_id } = data.payload;

    const result = yield call(
      sendRequest,
      api.get,
      { search: { page, pageSize, column, order, filter, parent_id } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      const { records, totalCount, filteredCount, sortable_columns } = result.data;

      yield put(
        actions.loadDataSuccess({
          data: records,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
